import "./carousel.css";

import carousel1 from "../../assets/images/carousel/carousel1.png";
import carousel2 from "../../assets/images/carousel/carousel2.png";
import carousel3 from "../../assets/images/carousel/carousel3.png";
import carousel4 from "../../assets/images/carousel/carousel4.png";
import carousel5 from "../../assets/images/carousel/carousel5.png";
import carousel6 from "../../assets/images/carousel/carousel6.png";

function getCard(title: string, img: string) {
    return <div className="card">
        <img className="cardImage" src={img} alt={title} />
        <p>{title}</p>
    </div>
}

function getGroup(ariaHidden: boolean = false) {
    return (
        <div className="group" aria-hidden={ariaHidden}>
            {getCard('Supermercados', carousel1)}
            {getCard('Academias', carousel2)}
            {getCard('Igrejas', carousel3)}
            {getCard('Escritórios', carousel4)}
            {getCard('Lojas', carousel5)}
            {getCard('Concessionárias', carousel6)}
        </div>
    );
}

const carousel = () => {

    return (
        <div className="carrouselMain">
            <div className="carouselTitle">
                <p>ONDE ATUAMOS</p>
            </div>
            <div className="carousel">
                {getGroup(false)}
                {getGroup(true)}
            </div>
        </div>
    );
};

export default carousel;
